import { Skeleton } from '@mui/material';
import { FC, memo } from 'react';
import { PatientProfileHeaderSkeleton } from './header/header.skeleton';
import { NavbarSkeleton } from './navigation/navbar/navbar.skeleton';
import { Content, PatientProfilePageWrapper } from './patient-profile-page.styles';
import { OverviewViewSkeleton } from './views/overview/overview.skeleton';

export const PatientProfilePageSkeleton: FC = memo(() => (
  <PatientProfilePageWrapper>
    <Content>
      <PatientProfileHeaderSkeleton />
      <NavbarSkeleton />
      <OverviewViewSkeleton />
    </Content>
    <Skeleton variant="rectangular" width={434} height="100%" sx={{ marginLeft: 'auto' }} />
  </PatientProfilePageWrapper>
));
